export const constructPackagePageURL = (
	content: Queries.ContentfulGuideline,
	categorySlug: string,
) => {
	return content.contentfulparent && content.contentfulparent.slug
		? `/${categorySlug}/${content.contentfulparent.slug}/${content.slug}`
		: `/${categorySlug}/${content.slug}`;
};
